import React from "react";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../../components/header/HeaderDefault";
import CopyRight from "../../../components/footer/copyright/CopyRight";
import Footer from "../../../components/footer/Footer";
import ServiceList from "../../../components/list/ServiceList";
import ServiceFaq from "../../../components/faq/ServiceFaq";
import Skills from "../../../components/skill/Skills";
import WebServiceApproach from "../../../components/service/WebServiceApproach";
import CounterThree from "../../../components/counter/CounterThree";
import WebServiceBestThings from "../../../components/service/WebServiceBestThings";
import ImageGridFive from "../../../components/image-grid/ImageGridFive";

const WebService = () => {
    return (
        <div>
            <Helmet>
                <title>Multi Cloud Ai - Web App Devlopment</title>
            </Helmet>
            {/* End Page SEO Content */}

            <HeaderDefault />
            {/* End Header */}

            <div className="ptf-main">
                <div className="ptf-page ptf-page--service-detail">
                    <section>

                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-9">
                                    {/* <!--Animated Block--> */}

                                </div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <h1 className="large-heading2 text-center"
                                    >One-Stop Software Development Company</h1>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        Multi Cloud Ai one of the leading Software Development Company
                                        working worldwide to offer vigorous highly competitive, client
                                        focused services, persistent supervision and transparency with
                                        guidance of our experienced professionals.
                                        {/*spacer !! */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "0.5rem" }}
                                        >
                                        </div>
                                        We aim to create your online business experience remarkable,
                                        eminent, dynamic, speedy and efficient. Our core purpose is to achieve
                                        your contentment by accomplishing your objectives  designing fully customized
                                        and responsive websites for your organizations that are valuable and economical at the same time.
                                    </p>

                                    <ImageGridFive />

                                </div>
                                {/* <!--Spacer--> */}
                                <div
                                    className="ptf-spacer"
                                    style={{ "--ptf-xxl": "5rem" }}
                                ></div>
                                <div
                                    className="ptf-animated-block"
                                    data-aos="fade"
                                    data-aos-delay="0"
                                >
                                    <h4>Build Fully Custom Products for Company with A Best Class Software And Applications</h4>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "1.5rem" }}
                                    ></div>
                                    <p className="fz-18 my_background" >
                                        Multi Cloud Ai is a custom software development company that
                                        offers wide range of  comprehensive IT Services such as
                                        web app development,  backend development, UI and UX design,
                                        mobile app development for iOS and Android and  software consulting.
                                        Multi Cloud Ai integrate approach permits them to solve complex problems quickly
                                        with stability, maintainability  and scalability. The company is smart,
                                        well experienced and possess extensive knowledge about Open source solutions
                                        ( WordPress, WordPress Theme,  Joomla  and many more) customize web application
                                        development  and E- commerce solutions.  We constitute custom software applications
                                        and delineate turn key projects  to Start-ups and small medium enterprises.                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Top Portion */}

                    {/* <!--Spacer--> */}
                    <div
                        className="ptf-spacer"
                        style={{ "--ptf-xxl": "6rem" }}
                    ></div>

                    <section
                        className="has-accent-1-background"
                        style={{
                            backgroundImage: `url("/assets/img/root/service-bubble.png")`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "100% calc(100% + 120px)",
                        }}
                    >
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5rem", "--ptf-md": "5rem" }}
                        ></div>
                        <div className="container-xxl">
                            {/* <!--Animated Block--> */}
                            <div
                                className="ptf-animated-block"
                                data-aos="fade"
                                data-aos-delay="1"
                            >
                                <h1 className="has-white-color large-heading">Experties in Web Development</h1>

                            </div>
                            {/* <!--Spacer--> */}
                            <div
                                className="ptf-spacer"
                                style={{ "--ptf-xxl": "7.5rem", "--ptf-md": " 3.75rem" }}
                            ></div>
                            <WebServiceApproach />
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
                        ></div>
                    </section>


                    <section>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "5.625rem", "--ptf-md": "2.8125rem" }}
                        ></div>
                        <div className="container-xxl">
                            <div className="row">
                                <div className="col-xl-8">
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>Increase Your Business Productivity</h2>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Why do clients trust working with us ?</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            Multi Cloud Ai always gives vigilant attention to time & punctuality
                                            which makes us unique from other organizations. We generally
                                            match up to clients' working style, by giving preference to
                                            establish direct mode of communication and stay open to each
                                            and every aspect. We always hear their pain points and provide
                                            immense assistance by the underlying main cause for it.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>The ROI Experts</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background ">
                                            Not only do we render assistance to overcome crucial barriers
                                            in development but also we demonstrate stick to our commitments.
                                            We enjoy delivering the projects in unexpected ways which gives
                                            our clients delighted and helps us to reward with trust.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "4.375rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h4>Best Practices With Testing</h4>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>
                                        <p className="fz-18 my_background">
                                            We provide cutting edge QA services to help businesses to initiate
                                            IT Services without any obstacles. VB Easy ensures that your custom
                                            web applications work flawlessly and can tackle any volume or load.
                                            This service unveils hidden obstacles so you can rest assured they
                                            must be addressed before issues arise.
                                            {/* <!--Spacer--> */}
                                            <div
                                                className="ptf-spacer"
                                                style={{ "--ptf-xxl": "0.5rem" }}
                                            ></div>
                                            We endeavor to provide impeccable product quality, validate compatibility
                                            and  put key focus on  Web Testing, QA testing services, Mobile App
                                            testing, UX Testing, Functional testing, Performance Testing, Cross- browser
                                            testing, Security Testing, API Testing & much more.
                                        </p>
                                    </div>

                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.125rem" }}
                                    ></div>
                                    <div
                                        className="row"
                                        style={{
                                            "--bs-gutter-x": "3.75rem",
                                            "--bs-gutter-y": "7.5rem",
                                        }}
                                    >
                                        <CounterThree />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h3>Our Skills</h3>
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "3.75rem" }}
                                    ></div>
                                    <div className="ptf-skill-box-grid">
                                        <Skills />
                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "6.875rem" }}
                                    ></div>
                                    {/* <!--Animated Block--> */}
                                    <div
                                        className="ptf-animated-block"
                                        data-aos="fade"
                                        data-aos-delay="0"
                                    >
                                        <h2>THE THINGS WE DO BEST</h2>
                                        {/* <!--Spacer--> */}
                                        <div
                                            className="ptf-spacer"
                                            style={{ "--ptf-xxl": "1.875rem" }}
                                        ></div>

                                    </div>
                                    {/* <!--Spacer--> */}
                                    <div
                                        className="ptf-spacer"
                                        style={{ "--ptf-xxl": "5.625rem" }}
                                    ></div>
                                    {/* <!--Process Steps--> */}
                                    <WebServiceBestThings />
                                </div>
                                <div className="col-xl-4">
                                    <div className="ptf-sidebar ptf-sidebar--right">
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-services-list">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">Services List</h4>
                                                <ServiceList />
                                            </div>
                                        </div>
                                        {/* <!--Widget--> */}
                                        <div className="ptf-widget ptf-widget-faq">
                                            {/* <!--Animated Block--> */}
                                            <div
                                                className="ptf-animated-block"
                                                data-aos="fade"
                                                data-aos-delay="0"
                                            >
                                                <h4 className="ptf-widget-title">FAQs</h4>
                                                <ServiceFaq />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--Spacer--> */}
                        <div
                            className="ptf-spacer"
                            style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
                        ></div>
                    </section>
                    {/* End .main content with sidebar */}
                </div>
                {/* End .ptf-page */}
            </div>
            {/* End ptf-main */}

            {/*=============================================
              Start Footer
              ============================================== */}
            <footer className="ptf-footer ptf-footer--style-1">
                <div className="container-xxl">
                    <div className="ptf-footer__top">
                        <Footer />
                    </div>
                    <div className="ptf-footer__bottom">
                        <CopyRight />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default WebService;
